import {
    AddBasketInformation,
    CreateBasket,
    GetBasket,
    GetBasketPayment,
    GetBasketPaymentCallback,
    GetBasketReceipt,
    SelectPaymentMethod,
} from 'libs/GrebbCommerceAPI/Basket';

import AddGiftCertToBasket from './routes/AddGiftCertToBasket';
import Cookies from 'js-cookie';
import { getState } from 'state';
import refreshCheckout from 'utils/refreshCheckout';

const BASKET_ID_COOKIE = 'gift_cert_basket_id';

export const setGiftCertBasketIdCookie = basketId => {
    const { path } = getState().application || { path: '/' };

    // Set the basketId for future usage.
    Cookies.set(BASKET_ID_COOKIE, basketId, {
        expires: 28,
        path: path || '/',
    });
};

export const clearGiftCertBasketIdCookie = () => {
    const { path } = getState().application || { path: '/' };
    Cookies.remove(BASKET_ID_COOKIE, { path: path || '/' });
};

export const getGiftCertBasketIdCookie = () => {
    const { path } = getState().application || { path: '/' };
    return Cookies.get(BASKET_ID_COOKIE, { path: path || '/' });
};

export const giftCertBasketSetup = async (application, giftCert) => {
    let basketId = getGiftCertBasketIdCookie();

    try {
        if (!basketId) {
            const response = await createGiftCertBasket(application);
            if (response.status === 200 || response.status === 201) {
                basketId = response.data.id;
            } else {
                throw response.error;
            }
        }

        const response = await addGiftCertToBasket(basketId, giftCert.id, giftCert.flexibleAmount);

        if (response.status === 200 || response.status === 201) {
            return response;
        }

        console.error('giftCertSetupFunc', response.error);

        throw response.error;
    } catch (error) {
        console.error('giftCertSetupFunc', error.error);
        throw error;
    }
};

export const createGiftCertBasket = async application => {
    // These are hardcoded for now. Should be read from state later.
    const {
        shop_config: { user_country: userCountry, market_id: marketId, pricelist_id: pricelistId, countries },
        locale,
        path,
        aliasId,
    } = application;

    const country = countries.find(({ id }) => id === userCountry) || countries[0];

    try {
        const response = await CreateBasket(country.id, marketId, pricelistId, locale, aliasId);
        if (response.status === 200 || response.status === 201) {
            // Set the basketId for future usage.
            setGiftCertBasketIdCookie(response.data.id, path);

            if (response.data?.payment_methods?.length) {
                return await refreshCheckout(
                    SelectPaymentMethod(response.data.id, response.data.payment_methods[0].id)
                );
            }

            return response;
        }

        throw response.error;
    } catch (error) {
        console.error('createBasket', error.error);
        throw error;
    }
};

export const addGiftCertToBasket = async (basketId, giftCertId, giftCertFlexibleAmount) => {
    try {
        const response = await refreshCheckout(AddGiftCertToBasket(basketId, giftCertId, giftCertFlexibleAmount));

        if (response.status === 200 || response.status === 201) {
            if (response.data?.payment_methods?.length && !response.data?.payment_method) {
                return await refreshCheckout(
                    SelectPaymentMethod(response.data.id, response.data.payment_methods[0].id)
                );
            }
            return response;
        }

        throw response.error;
    } catch (error) {
        console.error('addGiftCertToBasket', error.error);
        throw error;
    }
};

export const getGiftCertBasket = async () => {
    const basketId = getGiftCertBasketIdCookie();

    try {
        if (basketId) {
            const response = await GetBasket(basketId);

            if (response.status === 200 || response.status === 201) {
                return response;
            }

            throw response.error;
        }
    } catch (error) {
        console.error('getGiftCertBasket', error.error);
        throw error;
    }
};

export const addGiftCertBasketInformation = async data => {
    const basketId = getGiftCertBasketIdCookie();
    try {
        if (basketId) {
            const response = await refreshCheckout(AddBasketInformation(basketId, data));

            if (response.status === 200 || response.status === 201) {
                return response;
            }

            throw response.error;
        }
    } catch (error) {
        console.error('getGiftCertBasket', error.error);
        throw error;
    }
};

export const getGiftCertBasketPayment = async (
    paymentMethodId,
    successUrl,
    errorUrl,
    language,
    address,
    extras = null,
    country = null
) => {
    const basketId = getGiftCertBasketIdCookie();
    const state = address.state || '';

    try {
        if (basketId) {
            return await refreshCheckout(
                GetBasketPayment(
                    basketId,
                    paymentMethodId,
                    successUrl,
                    errorUrl,
                    language,
                    country,
                    state,
                    address,
                    extras
                )
            );
        }
    } catch (error) {
        console.error('getGiftCertBasket', error.error);
        throw error;
    }
};

export const getGiftCertBasketReceipt = async basketId => {
    const id = basketId ? basketId : getGiftCertBasketIdCookie();
    return await GetBasketReceipt(id);
};

export const getGiftCertBasketPaymentCallback = async data => {
    const basketId = getGiftCertBasketIdCookie();

    if (!basketId) {
        // eslint-disable-next-line no-throw-literal
        throw 'No basket id found';
    }

    // eslint-disable-next-line
    const response = await GetBasketPaymentCallback(basketId, data);

    return response;
};
